import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";
import Select from "react-select";
import Crop from "../../shared/crop";

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};
const Add = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [imagePreview, setImagePreview] = useState("");
  const [isError, setError] = useState(false);
  const [sizeDrp, setSizeDrpData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productDrp, setProductDrpData] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    size_id: "",
    product_id: "",
    image: "",
    weight: "",
    image_url: "",
  });

  const getProductData = () => {
    axios.post(API_URL.PRODUCT_ONLY_LIST, {}).then((res) => {
      setProductDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setProductDrpData(cd);
    });
  };

  const getSizeData = () => {
    axios.post(API_URL.SIZE_LIST, {}).then((res) => {
      setSizeDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setSizeDrpData(cd);
    });
  };

  const onSave = () => {
    if (
      formData.name &&
      formData.size_id &&
      formData.weight &&
      formData.product_id &&
      (id ? true : formData.image)
    ) {
      setError(false);
      setLoading(true);
      const pUrl = id ? API_URL.SUB_PRODUCT_UPDATE : API_URL.SUB_PRODUCT_SAVE;
      axios
        .post(pUrl, formData)
        .then((res) => {
          if (res.data.status === 1) {
            let message = id
              ? "Sub Product Updated Successfully."
              : "Sub Product Created Successfully.";
            toast.success(message, { autoClose: 3000, position: "top-right" });
            setLoading(false);
            navigate("/admin/subproduct");
          }
        })
        .finally(() => {
          setError(false);
          setLoading(false);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.SUB_PRODUCT_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          product_id: res.data.data.product_id ? res.data.data.product_id : "",
          weight: res.data.data.weight ? res.data.data.weight : "",
          size_id: res.data.data.size_id ? res.data.data.size_id : "",
          image_url: res.data.data.image ? res.data.data.image : "",
        });
        setImagePreview(res.data.data.image ? res.data.data.image : "");
      }
    });
  };

  const isRequiredField = (key) => {
    return isError && !formData[key];
  };

  useEffect(() => {
    getProductData();
  }, []);

  useEffect(() => {
    getSizeData();
  }, []);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  const styles = {
    menu: (baseStyles, state) => ({
      ...baseStyles,
      marginTop: 2,
      zIndex: 999,
    }),
  };

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Update" : "Add"} Sub Product</h5>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>
                    Name<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    maxLength={30}
                    value={formData.name}
                    className={
                      isRequiredField("name")
                        ? "form-control required"
                        : "form-control"
                    }
                    id="name"
                    onChange={(event) => {
                      setFormData({ ...formData, name: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="Product">
                    Product<span className="required-star">*</span>
                  </label>
                  <Select
                    placeholder=""
                    options={productDrp}
                    value={productDrp.find(
                      (r) => r.value == formData.product_id
                    )}
                    styles={
                      isRequiredField("product_id")
                        ? customRequireStyles
                        : customStyles
                    }
                    onChange={(e) =>
                      setFormData({ ...formData, product_id: e.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor="Size">
                    Size<span className="required-star">*</span>
                  </label>
                  <Select
                    placeholder=""
                    options={sizeDrp}
                    value={sizeDrp.find((r) => r.value == formData.size_id)}
                    styles={
                      isRequiredField("size_id")
                        ? customRequireStyles
                        : customStyles
                    }
                    onChange={(e) =>
                      setFormData({ ...formData, size_id: e.value })
                    }
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>
                    Weight<span className="required-star">*</span>
                  </label>
                  <input
                    type="number"
                    name="name"
                    maxLength={30}
                    value={formData.weight}
                    className={
                      isRequiredField("weight")
                        ? "form-control required"
                        : "form-control"
                    }
                    id="weight"
                    onChange={(event) => {
                      setFormData({ ...formData, weight: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        Image<span className="required-star">*</span>
                      </label>
                      <div
                        className={isRequiredField("image") && "required-box"}
                      >
                        <Crop
                          imagePreview={imagePreview}
                          cropShape={"round"}
                          guid={""}
                          onChangeCropper={async ({
                            fileCropped,
                            fileCroppedBase64,
                          }) => {
                            setFormData({
                              ...formData,
                              image: fileCroppedBase64,
                            });
                            setImagePreview(fileCroppedBase64);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                <div className="text-end">
                  <Link
                    to={"/admin/subproduct"}
                    className={
                      loading
                        ? "btn btn-danger btn-sm me-2 disabled-link"
                        : "btn btn-danger btn-sm me-2"
                    }
                    onClick={(e) => loading && e.preventDefault()}
                  >
                    Cancel
                  </Link>
                  <button
                    type="button"
                    onClick={onSave}
                    disabled={loading}
                    className="btn btn-primary btn-sm"
                  >
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      {loading && (
                        <Watch color={"white"} height={15} width={15} />
                      )}
                      Submit
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Add;
